module.exports = __webpack_public_path__ + "static/media/canceled.3c04848e.png";